import submissions from '@/api/submissions';
import products from '@/api/products';
import forms from '@/api/forms';
import tagApi from '@/api/tag';
import contactApi from '@/api/contacts';
import { duplicateVar } from '../../lib/helper';

const SET_PRODUCTS = 'SET_PRODUCTS';
const SET_IS_FETCHING_PRODUCTS = 'SET_IS_FETCHING_PRODUCTS';
const SET_FORMS = 'SET_FORMS';
const SET_IS_FETCHING_FORMS = 'SET_IS_FETCHING_FORMS';
const CLEAR_FORMS = 'CLEAR_FORMS';
const EDIT_SUBMISSION = 'EDIT_SUBMISSION';
const EDIT_SUBMISSION_CUSTOMER = 'EDIT_SUBMISSION_CUSTOMER';
const UPDATE_PRINTED_SUBMISSION = 'UPDATE_PRINTED_SUBMISSION';
const UPDATE_ORDER_RECEIPTS = 'UPDATE_ORDER_RECEIPTS';
const RESET_NEW_ORDERS = 'RESET_NEW_ORDERS';
const SET_PAYMENT_STATUS = 'SET_PAYMENT_STATUS';
const UPDATE_BULK_STATUS = 'UPDATE_BULK_STATUS';
const UPDATE_BULK_PAYMENT_STATUS = 'UPDATE_BULK_PAYMENT_STATUS';
const UPDATE_ASSIGN_TEAM = 'UPDATE_ASSIGN_TEAM';
const ADD_DETAIL = 'ADD_DETAIL';

// tag
const SET_TAGS = 'SET_TAGS';
const APPEND_TAGS = 'APPEND_TAGS';
const UPDATED_SUBMISSION_TAG = 'UPDATED_SUBMISSION_TAG';
const UPDATED_SUBMISSIONS_TAG = 'UPDATED_SUBMISSIONS_TAG';

// contact
const SET_CONTACTS = 'SET_CONTACTS';
const SET_IS_FETCHING_CONTACTS = 'SET_IS_FETCHING_CONTACTS';

const compareProducts = (a, b) => {
	// Use toUpperCase() to ignore character casing
	const nameA = a.name.toUpperCase();
	const nameB = b.name.toUpperCase();

	let comparison = 0;
	if (nameA > nameB) {
		comparison = 1;
	} else if (nameA < nameB) {
		comparison = -1;
	}
	return comparison;
};

const state = {
	all: [],
	products: [],
	forms: [],
	newOrderIds: [],
	isFetchingProducts: false,
	isFetchingForms: false,
	isFetching: false,
	isAll: false,
	page: 1,
	tags: [],
	isFetchingContacts: false,
	contacts: [],
	details: [],
};

const getters = {
	products: state => state.products,
	forms: state => state.forms,
	all: state => state.all,
	newOrderIds: state => state.newOrderIds,
	isFetchingProducts: state => state.isFetchingProducts,
	isFetchingForms: state => state.isFetchingForms,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	tags: state => state.tags,
	isFetchingContacts: state => state.isFetchingContacts,
	contacts: state => state.contacts,
	details: state => state.details,
};

const mutations = {
	setSubmissions(state, submissions) {
		state.all = submissions;
	},
	appendSubmissions(state, submissions) {
		// state.all = state.all.concat(submissions);
		for (let index = 0; index < submissions.length; index++) {
			const submission = submissions[index];
			state.all.push(submission);
		}
	},
	clearSubmissions(state) {
		state.all = [];
	},
	resetSubmissions(state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	setIsFetching(state, status) {
		state.isFetching = status;
	},
	setProgress(state, { id, progress }) {
		const index = state.all.findIndex(item => item._id === id);
		if (index !== -1) {
			state.all[index].progress = progress;
		}
	},
	setStatus(state, { id, status, receiptNumber, paymentStatus }) {
		const index = state.all.findIndex(item => item._id === id);
		if (index !== -1) {
			state.all[index].status = status;
			if (receiptNumber && state.all[index].shipping) {
				state.all[index].shipping.receipt_number = receiptNumber;
			}
			if (paymentStatus && state.all[index].payment) {
				state.all[index].payment.status = paymentStatus;
			}
		}
	},
	[SET_PAYMENT_STATUS](state, { id, status }) {
		const index = state.all.findIndex(item => item._id === id);
		if (index !== -1) {
			state.all[index].payment.status = status;
		}
	},
	setStatusByOrderId(state, { orderId, status, receiptNumber }) {
		const orderIdInt = parseInt(orderId);
		const index = state.all.findIndex(item => item.order_id === orderIdInt);
		if (index !== -1) {
			state.all[index].status = status;
			state.all[index].shipping.receipt_number = receiptNumber;
		}
	},
	updateOrders(state, orders) {
		for (let index = 0; index < orders.length; index++) {
			const order = orders[index];
			const orderIdInt = parseInt(order.order_id);
			const payload = order.payload;
			const orderIndex = state.all.findIndex(item => item.order_id === orderIdInt);
			if (orderIndex !== -1) {
				const keys = Object.keys(payload);
				for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
					const key = keys[keyIndex];
					const value = payload[key];
					if (key === 'receipt_number') {
						const shipping = duplicateVar(state.all[orderIndex].shipping);
						shipping.receipt_number = value;
						state.all[orderIndex].shipping = shipping;
					} else if (key === 'pickup') {
						const shipping = duplicateVar(state.all[orderIndex].shipping);
						shipping.pickup = value;
						state.all[orderIndex].shipping = shipping;
					} else if (key === 'status') {
						state.all[orderIndex].status = value;
					}
				}
			}
		}
	},
	delete(state, index) {
		state.all.splice(index, 1);
	},
	setPage(state, page) {
		state.page = page;
	},
	addPage(state) {
		state.page++;
	},
	setIsAll(state, isAll) {
		state.isAll = isAll;
	},
	[SET_IS_FETCHING_PRODUCTS](state, value) {
		state.isFetchingProducts = value;
	},
	[SET_PRODUCTS](state, products) {
		state.products = products;
	},
	[SET_IS_FETCHING_FORMS](state, value) {
		state.isFetchingForms = value;
	},
	[SET_FORMS](state, forms) {
		state.forms = forms;
	},
	[CLEAR_FORMS](state) {
		state.forms = [];
	},
	[EDIT_SUBMISSION](state, submission) {
		const index = state.all.findIndex(currSubmission => currSubmission._id === submission._id);
		if (index !== -1) {
			state.all[index] = submission;
		}
	},
	[EDIT_SUBMISSION_CUSTOMER](state, order) {
		const index = state.all.findIndex(currSubmission => currSubmission._id === order._id);
		if (index !== -1) {
			const submission = duplicateVar(state.all[index]);
			const currentCustomerData = submission.customer_data;
			const updatedCustomerData = order.customer_data;
			const newCustomerData = Object.assign({}, currentCustomerData, updatedCustomerData);
			submission.customer_data = newCustomerData;
			state.all[index] = submission;
		}
	},
	[UPDATE_PRINTED_SUBMISSION](state, ids) {
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const submissionIndex = state.all.findIndex(currSubmission => currSubmission._id === id);
			if (submissionIndex !== -1) {
				state.all[submissionIndex].is_printed = true;
				if (state.all[submissionIndex].status === 'pending') {
					state.all[submissionIndex].status = 'processing';
				}
			}
		}
	},
	[UPDATE_ORDER_RECEIPTS](state, { orders, status }) {
		orders.forEach((order) => {
			const index = state.all.findIndex(curOrder => curOrder.order_id === order.order_id);
			if (index !== -1) {
				state.all[index].status = status;
				state.all[index].shipping.receipt_number = order.receipt_number;
			}
		});
	},
	[RESET_NEW_ORDERS](state) {
		state.newOrderIds = [];
	},
	SOCKET_ORDER_ADD(state, value) {
		const orderId = value.id;
		if (orderId) {
			state.newOrderIds.push(orderId);
		}
	},
	[UPDATE_BULK_STATUS](state, submission) {
		const ids = submission.ids;
		const status = submission.status;
		const paymentStatus = submission.paymentStatus ? submission.paymentStatus : '';

		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const statusIndex = state.all.findIndex(curr => curr.order_id === id);
			if (statusIndex !== -1) {
				state.all[statusIndex].status = status;
				const order = state.all[statusIndex];
				const paymentMethod = order?.payment?.method ?? 'bank_transfer';
				if (paymentStatus !== '' && paymentMethod !== 'instant') {
					state.all[statusIndex].payment.status = paymentStatus;
				}
			}
		}
	},
	[UPDATE_BULK_PAYMENT_STATUS](state, submission) {
		const ids = submission.ids;
		const paymentStatus = submission.paymentStatus;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const statusIndex = state.all.findIndex(curr => curr.order_id === id);
			if (statusIndex !== -1) {
				state.all[statusIndex].payment.status = paymentStatus;
			}
		}
	},
	[UPDATE_ASSIGN_TEAM](state, payload) {
		const ids = payload.ids;
		const team = payload.team;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const statusIndex = state.all.findIndex(curr => curr.order_id === id);
			if (statusIndex !== -1) {
				state.all[statusIndex].belongs_to = [team];
			}
		}
	},

	// tgs
	[SET_TAGS](state, tags) {
		state.tags = tags;
	},
	[APPEND_TAGS](state, tags) {
		state.tags = state.tags.concat(tags);
	},
	[UPDATED_SUBMISSION_TAG](state, order) {
		const orderIndex = state.all.findIndex(curr => curr._id === order._id);
		if (orderIndex !== -1) {
			state.all[orderIndex].tags = order.tags;
		}
	},
	[UPDATED_SUBMISSIONS_TAG](state, data) {
		const ids = data.ids;
		const tags = data.tags;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const orderIndex = state.all.findIndex(curr => curr._id === id);
			if (orderIndex !== -1) {
				state.all[orderIndex].tags = tags;
			}
		}
	},

	// contacts
	[SET_CONTACTS](state, contacts) {
		state.contacts = contacts;
	},
	[SET_IS_FETCHING_CONTACTS](state, value) {
		state.isFetchingContacts = value;
	},

	[ADD_DETAIL](state, detail) {
		state.details.push(detail);
	},
};

const actions = {
	getProducts({ commit, getters }) {
		if (!getters.isFetchingProducts) {
			commit(SET_IS_FETCHING_PRODUCTS, true);
			const params = {
				get_product_url: 1,
				sort_by: 'name',
				sort: 'asc',
			};
			const callback = (response) => {
				const products = response.data;
				products.sort(compareProducts);
				commit(SET_PRODUCTS, products);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			// products.getProductsList(callback, errorCallback);
			products.getMinimalProducts(params, callback, errorCallback);
		}
	},
	getForms({ commit, getters }, productId) {
		if (!getters.isFetchingForms) {
			commit(SET_IS_FETCHING_FORMS, true);
			const params = {
				product_id: productId,
				limit: 25,
				sort_by: 'name',
				sort: 'asc',
				page: 1,
				keyword: '',
			};
			const callback = (response) => {
				const forms = response.data;
				commit(SET_FORMS, forms);
				commit(SET_IS_FETCHING_FORMS, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_FORMS, false);
			};
			forms.getForms(params, callback, errorCallback);
		}
	},
	getSubmissions({ commit, getters }, params) {
		if (!getters.isFetching && !getters.isAll) {
			commit('setIsFetching', true);
			const callback = (response) => {
				const submissions = response.data;
				if (submissions.length !== 0) {
					commit('appendSubmissions', submissions);
					commit('addPage');
				} else {
					commit('setIsAll', true);
				}
				commit('setIsFetching', false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit('setIsFetching', false);
			};
			submissions.getSubmissions(params, callback, errorCallback);
		}
	},
	changeProgress({ commit }, payload) {
		commit('setProgress', payload);
	},
	changeStatus({ commit }, payload) {
		commit('setStatus', payload);
	},
	changePaymentStatus({ commit }, payload) {
		commit(SET_PAYMENT_STATUS, payload);
	},
	changeStatusByOrderId({ commit }, params) {
		const payload = {
			orderId: params.order_id,
			status: params.status,
			receiptNumber: params.receipt_number,
		};
		commit('setStatusByOrderId', payload);
	},
	delete({ commit }, index) {
		commit('delete', index);
	},
	setPage({ commit }, value) {
		commit('setPage', value);
	},
	setIsAll({ commit }, isAll) {
		commit('setIsAll', isAll);
	},
	clearSubmissions({ commit }) {
		commit('clearSubmissions');
	},
	resetSubmissions({ commit }) {
		commit('resetSubmissions');
	},
	updateSubmission({ commit }, submission) {
		commit(EDIT_SUBMISSION, submission);
	},
	updateSubmissionCustomer({ commit }, submission) {
		commit(EDIT_SUBMISSION_CUSTOMER, submission);
	},
	clearForms({ commit }) {
		commit(CLEAR_FORMS);
	},
	updatePrinted({ commit }, ids) {
		commit(UPDATE_PRINTED_SUBMISSION, ids);
	},
	updateOrderReceipts({ commit }, payload) {
		commit(UPDATE_ORDER_RECEIPTS, payload);
	},
	resetNewOrders({ commit }) {
		commit(RESET_NEW_ORDERS);
	},
	updateBulkStatus({ commit }, submission) {
		commit(UPDATE_BULK_STATUS, submission);
	},
	updateBulkPaymentStatus({ commit }, submission) {
		commit(UPDATE_BULK_PAYMENT_STATUS, submission);
	},
	updateOrders({ commit }, orders) {
		commit('updateOrders', orders);
	},
	addDetail({ commit }, detail) {
		commit(ADD_DETAIL, detail);
	},
	// tags
	getSubmissionTags({ commit }, params) {
		const callback = (response) => {
			const tags = response.data;
			if (tags.length !== 0) {
				commit(SET_TAGS, tags);
			}
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
		};
		tagApi.getTags(params, callback, errorCallback);
	},
	setAppendTag({ commit }, value) {
		commit(APPEND_TAGS, value);
	},
	updatedSubmissionTag({ commit }, value) {
		commit(UPDATED_SUBMISSION_TAG, value);
	},
	updatedSubmissionsTag({ commit }, value) {
		commit(UPDATED_SUBMISSIONS_TAG, value);
	},
	updateAssignTeam({ commit }, payload) {
		commit(UPDATE_ASSIGN_TEAM, payload);
	},
	// contacts
	getSubmissionContacts({ commit }, params) {
		commit(SET_IS_FETCHING_CONTACTS, true);
		const callback = (response) => {
			const contacts = response.data;
			if (contacts) {
				commit(SET_IS_FETCHING_CONTACTS, false);
				commit(SET_CONTACTS, contacts);
			}
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);

			commit(SET_IS_FETCHING_CONTACTS, false);
		};
		contactApi.getSeacrhContacts(params, callback, errorCallback);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
